/**
 * Wanneer de TURN-credentials opnieuw op te halen.
 *
 * CARO-Api (`buildIceServers`) zet de vervaltijd in de gebruikersnaam:
 * `<unix-seconden>:<extensie>`, standaard 24 u na het ophalen. Ververs op de helft van
 * wat er nog rest, begrensd zodat een scheve klok of een rare TTL geen storm van
 * verzoeken of een gat van dagen oplevert.
 */
export const ICE_REFRESH_MIN_MS = 5 * 60_000;
export const ICE_REFRESH_MAX_MS = 12 * 60 * 60_000;
/** Geen leesbare vervaltijd (alleen STUN, of een ander formaat): toch periodiek verversen. */
export const ICE_REFRESH_FALLBACK_MS = 6 * 60 * 60_000;

export function nextIceRefreshDelay(
  iceServers: Array<{ urls: string | string[]; username?: string }>,
  now = Date.now(),
): number {
  const expiries = iceServers
    .map((s) => Number.parseInt((s.username || '').split(':')[0], 10))
    .filter((n) => Number.isFinite(n) && n > 0);
  if (expiries.length === 0) return ICE_REFRESH_FALLBACK_MS;
  const remainingMs = Math.min(...expiries) * 1000 - now;
  return Math.min(Math.max(remainingMs / 2, ICE_REFRESH_MIN_MS), ICE_REFRESH_MAX_MS);
}
